// Yup
import * as yup from 'yup';
const cnpjIsInvalid = (cnpj: any) => {
  return /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/g.test(cnpj);
};

const paymentMethodSchema = yup.object().shape({
  type: yup.mixed().oneOf(['PIX', 'BOLETO', 'CARD']),
  bank: yup.mixed().oneOf(['SICREDI', 'BB', 'SANTANDER', 'CAIXA', 'CIELO']),
  status: yup
    .number()
    .required('Campo obrigatório')
    .typeError('Valor deve ser um número'),
  PaymentCardConfig: yup.object().shape({
    username: yup.string().required('Campo obrigatório'),
    password: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    description: yup.string().required('Campo obrigatório'),
    min: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Valor deve ser um número')
      .min(0, 'Valor muito pequeno')
      .max(5000, 'Valor muito grande!'),
    max: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Valor deve ser um número')
      .min(0, 'Valor muito pequeno')
      .max(5000, 'Valor muito grande!'),
    antifraudUsername: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    antifraudPassword: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    antifraudId: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
  }),
  PaymentPixConfig: yup.object().shape({
    expiration: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    description: yup.string().required('Campo obrigatório'),
    operator: yup.string().required('Campo obrigatório'),
    name: yup.string().required('Campo obrigatório'),
    min: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Valor deve ser um número')
      .min(0, 'Valor muito pequeno')
      .max(5000, 'Valor muito grande!'),
    key: yup.string().required('Campo obrigatório'),
    username: yup.string().required('Campo obrigatório'),
    password: yup.string().required('Campo obrigatório'),
    certificate: yup.string().required('Campo obrigatório'),
    certificatePassword: yup.string().required('Campo obrigatório'),
  }),
  PaymentBoletoConfig: yup.object().shape({
    expiration: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    description: yup.string().required('Campo obrigatório'),
    min: yup
      .number()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    authToken: yup.string().required('Campo obrigatório'),
    key: yup.string().required('Campo obrigatório'),
    username: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    password: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    certificate: yup.string().required('Campo obrigatório'),
    certificatePassword: yup.string().required('Campo obrigatório'),
    agency: yup.string().required('Campo obrigatório'),
    place: yup.string().required('Campo obrigatório'),
    cedente: yup.string().required('Campo obrigatório'),
    name: yup.string().required('Campo obrigatório'),
    document: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório')
      .test('Digite um CNPJ válido', 'Digite um CNPJ válido', (cnpj) =>
        cnpjIsInvalid(cnpj),
      ),
    account: yup.string().required('Campo obrigatório'),
    number: yup
      .string()
      .required('Campo obrigatório')
      .typeError('Campo obrigatório'),
    convenio: yup.string().required('Campo obrigatório'),
  }),
});

export default paymentMethodSchema;
export { paymentMethodSchema };
